<div style="
    height: 100%;
    width: 100%;
    min-height: 950px;
    background-color: black;
    background-image: url(../../../assets/images/background.png);
  ">
  <div class="opacity-holder"></div>
</div>

<div class="nlogin heading">
  <div class="headingholder-title">
    <span class="headingholder1">Pay</span>
    <span class="headingholder2">Day</span>
    <span class="headingholder3">Portal</span>
    <span class="headingholder4">.com</span>
  </div>
  <div class="headingholder-logo">
    <span class="logo" translate>login.PoweredBy</span>
    <span> <img src="assets/images/logo.png" /></span>
  </div>
  <div class="rightsreserved">
    <span>{{copyrightInfo}}</span>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="login()" class="nlogin">
  <div class="centralized">
    <div class="transparentframe">
      <div class="signin" translate>login.SignIn</div>
      <div class="registeredonly">
        ({{ "login.RegisteredOnly" | translate }})
      </div>
      <div style="margin-top: 20px">
        <ul class="list-unstyled">
          <li>
            <div class="ui-inputgroup">
              <span class="ui-inputgroup-addon form-input-icon">
                <i class="far fa-user"></i>
              </span>
              <input id="user"
                     type="text"
                     pInputText
                     placeholder="{{ 'login.Username' | translate }}"
                     formControlName="user"
                     class="form-input"
                     style="height: 50px" />
            </div>
            <div class="form-error">
              <div id="userValidation"
                   *ngIf="
                  !form.controls['user'].valid && form.controls['user'].dirty
                "
                   translate>
                login.UsernameRequired
              </div>
            </div>
          </li>
          <li>
            <div class="ui-inputgroup">
              <span class="ui-inputgroup-addon form-input-icon">
                <i class="fas fa-key"></i>
              </span>
              <input id="password"
                     type="password"
                     pPassword
                     [feedback]="false"
                     placeholder="{{ 'login.Password' | translate }}"
                     formControlName="password"
                     class="form-input"
                     style="height: 50px" />
            </div>
            <div class="form-error">
              <div id="passwordValidation"
                   *ngIf="
                  !form.controls['password'].valid &&
                  form.controls['password'].dirty
                "
                   translate>
                login.PasswordRequired
              </div>
            </div>
          </li>
          <li class="ui-inputgroup">
            <button class="button"
                    style="
                background-color: var(--text-nav-color-selected);
                border: none;
                color: white;
                text-decoration: none;
                text-transform: none;
                font-size: 17px;
                width: 326px;
                font-family: sans-serif;
                font-weight: normal;
                height: 50px;
                border-radius: 0 !important;
                text-align: left;
              "
                    id="signin"
                    pButton
                    type="submit"
                    label="{{ 'login.LogIn' | translate }}"
                    [disabled]="!form.valid || progress"></button>
          </li>
        </ul>
      </div>
      <div class="registeredonly">
        <a style="text-transform: uppercase" href="*" (click)="forgotPasswordClick($event)" translate>
          login.ForgotPassword
        </a>
      </div>
    </div>
  </div>
</form>


<p-dialog *ngIf="showForgotPassDialog"
          class="forgotpass"
          #forgotPass
          header="FORGOT PASSWORD?"
          [(visible)]="showForgotPassDialog"
          [modal]="true"
          [style]="{ width: dialogWidth }"
          [draggable]="false"
          [resizable]="false">
  <div *ngIf="!forgotPassFinalVisible"
       [formGroup]="forgotPassForm"
       class="nsignup"
       style="margin-top: 20px">
    <ul class="list-unstyled">
      <li>
        <div class="p-inputgroup">
          <span style="display: grid"
                class="p-inputgroup-addon form-input-icon">
            <div style="margin-top: -10px"><i class="fas fa-at"></i></div>
            <div style="margin-top: -10px"><i class="fas fa-mobile"></i></div>
          </span>
          <input id="emailOrPhone"
                 type="text"
                 pInputText
                 placeholder="{{ 'forgotPass.emailOrPhone' | translate }}"
                 formControlName="emailOrPhone"
                 class="form-input"
                 style="height: 50px" />
        </div>
        <div class="form-error" style="margin-left: 50px">
          <div id="emailOrPhoneValidation"
               *ngIf="
                !forgotPassForm.controls['emailOrPhone'].valid &&
                forgotPassForm.controls['emailOrPhone'].dirty
              "
               translate>
            forgotPass.emailOrPhoneRequired
          </div>
        </div>
      </li>
      <li>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon form-input-icon">
            <i class="fas fa-user"></i>
          </span>
          <input id="username"
                 type="text"
                 placeholder="{{ 'forgotPass.username' | translate }}"
                 formControlName="username"
                 class="form-input"
                 style="height: 50px" />
        </div>
        <div class="form-info" style="margin-left: 40px">
          <div id="usernameValidation"
               translate>
            forgotPass.usernameLeaveBlank
          </div>
        </div>
      </li>
      <li>
        <div style="margin-bottom: -20px">Google Captcha loading...</div>
        <div class="p-inputgroup">
          <re-captcha (resolved)="resolved($event)"
                      #captchaRef="reCaptcha"
                      [siteKey]="SITE_KEY"></re-captcha>
        </div>
      </li>
      <li class="p-inputgroup" style="margin-top: 30px">
        <button class="button"
                pButton
                label="{{ 'forgotPass.sendInquiry' | translate }}"
                [disabled]="!forgotPassForm.valid || !captchaValid"
                (click)="forgotPassRequest()"></button>
      </li>
    </ul>
  </div>
  <div *ngIf="forgotPassFinalVisible"
       [formGroup]="forgotPassFormFinal"
       class="nsignup"
       style="margin-top: 20px">
    <ul class="list-unstyled">
      <li>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon form-input-icon">
            <i class="fas fa-qrcode"></i>
          </span>
          <input autocomplete="new"
                 id="emailOrPhone"
                 type="text"
                 placeholder="{{ 'forgotPass.verificationCode' | translate }}"
                 formControlName="verificationCode"
                 class="form-input"
                 style="height: 50px" />
        </div>
        <div class="form-error">
          <div id="emailOrPhoneValidation"
               *ngIf="
                !forgotPassFormFinal.controls['verificationCode'].valid &&
                forgotPassFormFinal.controls['verificationCode'].dirty
              "
               translate>
            forgotPass.verificationCodeRequired
          </div>
        </div>
      </li>
      <li>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon form-input-icon">
            <i class="fas fa-key"></i>
          </span>
          <input autocomplete="new-password"
                 type="password"
                 [(ngModel)]="forgotPaswordFinalModel.newPassword"
                 formControlName="newPassword"
                 pPassword
                 [showPassword]="forgotPaswordFinalModel.showNew"
                 [feedback]="true"
                 placeholder="{{ 'login.newPassword' | gstranslate }}"
                 class="form-input"
                 style="
                height: 50px;
                width: 100%;
                border-right: 1px solid lightgray;
              " />
          <span *ngIf="forgotPaswordFinalModel.newPassword"
                (mousedown)="forgotPaswordFinalModel.showNew = true"
                (mouseup)="forgotPaswordFinalModel.showNew = false"
                class="change-pass-eye">
            <i class="fas fa-eye"></i>
          </span>
        </div>
        <div class="form-error">
          <div id="newPasswordValidation"
               *ngIf="
                !forgotPassFormFinal.controls['newPassword'].valid &&
                forgotPassFormFinal.controls['newPassword'].dirty
              "
               translate>
            {{ "login.newComplexPasswordRequired" | gstranslate }}
          </div>
        </div>
      </li>
      <li>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon form-input-icon">
            <i class="fas fa-key"></i>
          </span>
          <input autocomplete="new-password"
                 type="password"
                 [(ngModel)]="forgotPaswordFinalModel.confirmPassword"
                 formControlName="confirmPassword"
                 [showPassword]="forgotPaswordFinalModel.showConfirm"
                 pPassword
                 [feedback]="false"
                 placeholder="{{ 'login.confirmPassword' | gstranslate }}"
                 class="form-input"
                 style="
                height: 50px;
                width: 100%;
                border-right: 1px solid lightgray;
              " />
          <span *ngIf="forgotPaswordFinalModel.confirmPassword"
                (mousedown)="forgotPaswordFinalModel.showConfirm = true"
                (mouseup)="forgotPaswordFinalModel.showConfirm = false"
                class="change-pass-eye">
            <i class="fas fa-eye"></i>
          </span>
        </div>
        <div class="form-error">
          <div id="confirmPasswordValidation"
               *ngIf="
                !forgotPassFormFinal.controls['confirmPassword'].valid &&
                (forgotPassFormFinal.controls['confirmPassword'].dirty ||
                  forgotPassFormFinal.controls['newPassword'].dirty)
              "
               translate>
            {{ "login.confirmPasswordRequired" | gstranslate }}
          </div>
        </div>
      </li>

      <li class="p-inputgroup" style="margin-top: 30px">
        <button class="button"
                pButton
                label="{{ 'forgotPass.changePassword' | translate }}"
                [disabled]="!forgotPassFormFinal.valid"
                (click)="forgotPassRequestFinal()"></button>
      </li>
    </ul>
  </div>
</p-dialog>

<p-dialog [(visible)]="confirmationDialogVisible"
          [header]="confirmationHeader"
          modal="true"
          [closable]="true"
          class="signup">
  {{ confirmationMessage }}
  <p-footer>
    <button type="button"
            pButton
            icon="pi pi-check"
            (click)="closeConfirmationDialog()"
            label="{{ 'general.ok' | translate }}"></button>
  </p-footer>
</p-dialog>
